import moment from 'moment'
import { getItem, removeItem } from '@/base/utils/storage'

export const getStore = () =>
    sessionStorage.getItem('token') ? sessionStorage : localStorage

export const getToken = function () {
    let encryptedToken = getItem(getStore(), 'token')
    if (encryptedToken === null) return encryptedToken
    try {
        // Check if token was encrypted with proper crypto (contains ':')
        if (encryptedToken.includes(':')) {
            // Proper crypto decryption
            const crypto = require('crypto')
            const encryptionKey = getEncryptionKey()

            const [ivHex, encryptedData] = encryptedToken.split(':')
            const algorithm = 'aes-256-cbc'
            const key = crypto.createHash('sha256').update(encryptionKey).digest()
            const iv = Buffer.from(ivHex, 'hex')

            const decipher = crypto.createDecipheriv(algorithm, key, iv)
            let decrypted = decipher.update(encryptedData, 'hex', 'utf8')
            decrypted += decipher.final('utf8')
            return decrypted
        } else {
            // Legacy base64 fallback
            const decoded = window.atob(encryptedToken)
            return decoded
        }
    } catch (e) {
        clearToken()
        return null
    }
}
export const clearToken = function () {
    removeItem(getStore(), 'token')
    removeItem(getStore(), 'expiry_date')
}

export const getExpiryDate = function () {
    return getItem(getStore(), 'expiry_date')
}

export const tokenIsExpired = () => {
    return moment.duration(moment(getExpiryDate()).diff(moment())).asMinutes() < 0
}

export const decodeToken = token => {
    var base64Url = token.split('.')[1]
    var base64 = base64Url.replace('-', '+').replace('_', '/')
    return JSON.parse(window.atob(base64))
}

export const getEncryptionKey = function () {
    return 'userIp'
}

export const setToken = function (storage, token) {
    try {
        // Try to use crypto-browserify with a supported algorithm
        const crypto = require('crypto')
        const encryptionKey = getEncryptionKey()

        // Use createCipheriv instead of deprecated createCipher
        const algorithm = 'aes-256-cbc'
        const key = crypto.createHash('sha256').update(encryptionKey).digest()
        const iv = crypto.randomBytes(16)

        const cipher = crypto.createCipheriv(algorithm, key, iv)
        let encrypted = cipher.update(token, 'utf8', 'hex')
        encrypted += cipher.final('hex')

        // Store both IV and encrypted data
        const encryptedToken = iv.toString('hex') + ':' + encrypted
        storage.setItem('token', encryptedToken)
    } catch (error) {
        // Fallback to base64 if crypto fails
        const encryptedToken = window.btoa(token)
        storage.setItem('token', encryptedToken)
    }
}